var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "star-score", class: { large: _vm.large } },
    [
      !_vm.input
        ? [
            _vm._l(Math.floor(_vm.selectedScore), function(i) {
              return [
                _c("span", {
                  key: "full." + i,
                  domProps: { innerHTML: _vm._s(_vm.svg("star-solid-green")) }
                })
              ]
            }),
            _vm._v(" "),
            _vm.selectedScore - Math.floor(_vm.selectedScore) > 0
              ? [
                  _c("span", {
                    key: "half",
                    domProps: { innerHTML: _vm._s(_vm.svg("star-half-green")) }
                  })
                ]
              : _vm._e(),
            _vm._v(" "),
            _vm._l(5 - Math.ceil(_vm.selectedScore), function(i) {
              return [
                _c("span", {
                  key: "blank." + i,
                  domProps: { innerHTML: _vm._s(_vm.svg("star-solid-gray")) }
                })
              ]
            })
          ]
        : _vm._l(5, function(i) {
            return _c("span", {
              key: i,
              staticClass: "clickable",
              domProps: { innerHTML: _vm._s(_vm.svg(_vm.getStarType(i))) },
              on: {
                mouseover: function($event) {
                  return _vm.mouseover(i)
                },
                mouseleave: _vm.mouseleave,
                click: function($event) {
                  return _vm.submitScore(i)
                }
              }
            })
          })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }